import "core-js/modules/es.number.constructor.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "data-table-content"
};
var _hoisted_2 = {
  class: "pagination-class"
};
import { ref } from 'vue';
export default {
  __name: 'table',
  props: {
    columns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tdata: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    total: {
      type: Number,
      default: 100
    },
    pageSize: {
      type: Number,
      default: 20
    },
    defaultPage: {
      type: Number,
      default: 1
    },
    current: {
      type: Number,
      default: 1
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['changePage', 'changeCurrent', 'changePageSize'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var emits = __emit;
    var tableLayout = ref('fixed');
    var fixedTopAndBottomRows = ref(false);
    var onPageSizeChange = function onPageSizeChange(size) {
      // console.log('onPageSizeChange', size)
      emits('changePageSize', size);
    };

    // 切换当前页
    var onCurrentChange = function onCurrentChange(index, pageInfo) {
      // console.log(index, 62)
      emits('changeCurrent', index);
    };
    return function (_ctx, _cache) {
      var _component_t_table = _resolveComponent("t-table");
      var _component_t_pagination = _resolveComponent("t-pagination");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_t_table, {
        class: "table-class",
        loading: __props.loading,
        data: __props.tdata,
        "max-height": 500,
        "fixed-rows": fixedTopAndBottomRows.value ? [2, 2] : undefined,
        columns: __props.columns,
        "table-layout": tableLayout.value,
        resizable: "",
        "lazy-load": ""
      }, null, 8, ["loading", "data", "fixed-rows", "columns", "table-layout"]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_t_pagination, {
        total: __props.total,
        "page-size": __props.pageSize,
        current: __props.current,
        "default-page": __props.defaultPage,
        "show-jumper": "",
        onPageSizeChange: onPageSizeChange,
        onCurrentChange: onCurrentChange
      }, null, 8, ["total", "page-size", "current", "default-page"])])]);
    };
  }
};